import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {

    retrieveVariables({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("variable/retrieveVariables").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      saveVariable({ commit }, variable) {
        commit("SET_LOADING", true);
        return postAPI("variable/saveVariable", variable).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteVariable({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("variable/deleteVariable/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },
    
      retrieveVariableById({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("variable/retrieveVariableById" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveVariablesBySearch({ commit }, request) {
        commit("SET_LOADING", true);
        return getAPI("variable/retrieveVariablesBySearch" , request)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveInspectionTypes({ commit }, request) {
        commit("SET_LOADING", true);
        return getAPI("variable/retrieveInspectionTypes" , request)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      countVariables({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("variable/count").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },
};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };